import { ActionIcon, AppShell } from '@mantine/core';
import { useUnit } from 'effector-react';
import { X, Menu, PanelRightClose, PanelRightOpen } from 'lucide-react';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { AccountTree } from 'entities/account';
import { ViewerMenu } from 'entities/viewer';
import { adminLayoutModel } from '../../model';
import { AdminLayoutNavList } from '../admin-layout-nav-list';
import { AdminLayoutNavMenu } from '../admin-layout-nav-menu';
import { AdminLayoutOverlay } from '../admin-layout-overlay';
import cls from './admin-layout.module.scss';

export const AdminLayout = ({ children }: PropsWithChildren) => {
	const { t } = useTranslation();
	const navbarSwitcher = useUnit(adminLayoutModel.navbarSwitcher);
	const asideSwitcher = useUnit(adminLayoutModel.asideSwitcher);

	return (
		<AppShell
			header={{
				height: 60,
			}}
			navbar={{
				width: 360,
				breakpoint: '99999',
				collapsed: {
					mobile: !navbarSwitcher.active,
				},
			}}
			aside={{
				width: 360,
				breakpoint: 'xl',
				collapsed: {
					mobile: !asideSwitcher.active,
					desktop: !asideSwitcher.active,
				},
			}}
			className={cls.adminLayoutRoot}
		>
			<AppShell.Header
				zIndex={150}
				className={cls.adminLayoutHeader}
			>
				<div className={cls.adminLayoutHeaderLeft}>
					<ActionIcon
						hiddenFrom='xl'
						variant='outline'
						className={cls.adminLayoutBurger}
						data-test-id='admin-layout-navbar-toggle'
						onClick={navbarSwitcher.toggle}
					>
						{navbarSwitcher.active ? <X /> : <Menu />}
					</ActionIcon>
					<h3 className={cls.adminLayoutTitle}>{t('admin-layout.title')}</h3>
				</div>
				<AdminLayoutNavMenu visibleFrom='xl' />
				<div className={cls.adminLayoutHeaderRight}>
					<ViewerMenu />
					<ActionIcon
						className={cls.adminLayoutBurger}
						data-test-id='admin-layout-aside-toggle'
						onClick={asideSwitcher.toggle}
					>
						{asideSwitcher.active ? (
							<PanelRightClose className={cls.adminLayoutBurgerIcon} />
						) : (
							<PanelRightOpen className={cls.adminLayoutBurgerIcon} />
						)}
					</ActionIcon>
				</div>
			</AppShell.Header>
			<AppShell.Navbar
				className={cls.adminLayoutNavbar}
				hiddenFrom='xl'
			>
				<AdminLayoutNavList />
			</AppShell.Navbar>
			{children}
			<AdminLayoutOverlay hiddenFrom='xl' />
			<AppShell.Aside className={cls.adminLayoutAside}>
				<AccountTree />
			</AppShell.Aside>
		</AppShell>
	);
};
